import t from "./stateManager.js";
const e = new t(), a = { getState: () => {
  if (e.getState()) return JSON.parse(e.getState());
}, setState: (t2) => e.setState(JSON.stringify(t2)) };
export {
  a as default,
  a as state
};
//# sourceMappingURL=counterpartyAccountByIdentityManager.js.map
